module.exports = __webpack_public_path__ + "static/media/ce_logo.622efdac.svg";